/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Alert, Avatar, Box, Typography } from '@mui/material';

/*  Shared  */
import { LightTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';
import { Apple, Google, Windows } from 'application/Shared/Icons';

/*  React  */
import React from 'react';

const sources = {
    azure_username: 'Microsoft Entra ID Username',
    browser_extension: 'Chrome Account',
    device_name: 'Device Name',
    google_import: 'Google Username',
    upn: 'User Principal Name'
};

const icons = () => ({
    azure_username: <Windows variant="avatar" />,
    browser_extension: (
        <IconWithVariant
            data-testid="browserExtensionIcon"
            variant="avatar"
            src="Web"
            size={FontSizes[3]}
            wrapperProps={{ display: 'flex', justifyContent: 'center' }}
        />
    ),
    device_name: (
        <IconWithVariant
            data-testid="deviceNameIcon"
            variant="avatar"
            src="Laptop"
            size={FontSizes[3]}
            wrapperProps={{ display: 'flex', justifyContent: 'center' }}
        />
    ),
    google_import: <Google variant="avatar" />,
    upn: (
        <IconWithVariant
            data-testid="upnIcon"
            variant="avatar"
            src="Domain"
            size={FontSizes[3]}
            wrapperProps={{ display: 'flex', justifyContent: 'center' }}
        />
    )
});

const renderTooltip = (sourceKey, aliases, aliasOS) => {
    const source = sources[sourceKey];

    const header = <Typography fontWeight={600}>{source}</Typography>;
    if (!aliases || !aliases.length) {
        return (
            <Alert severity="info" icon={false}>
                {header}
                <small>Not Found</small>
            </Alert>
        );
    }

    return (
        <Alert severity="success" icon={false}>
            {header}
            {aliases.map((a) => {
                const os = aliasOS[a];

                return (
                    <Box
                        display="flex"
                        alignItems="center"
                        key={`alias_${sourceKey}_${a}`}
                    >
                        {os === 'MAC' && (
                            <Apple style={{ marginRight: '4px' }} />
                        )}
                        {os === 'WINDOWS' && (
                            <Windows style={{ marginRight: '4px' }} />
                        )}
                        <small>{a}</small>
                    </Box>
                );
            })}
        </Alert>
    );
};

const Alias = ({ alias, aliases, aliasOS, orderedKey }) => {
    const source = orderedKey ? orderedKey.substr(2) : '';
    const text = alias || 'Not Found';

    return (
        <Box display="flex" alignItems="center" marginBottom="16px">
            <LightTooltip
                title={renderTooltip(source, aliases, aliasOS)}
                placement="left"
            >
                <Avatar
                    sx={{
                        backgroundColor: 'background.avatar',
                        height: '35px',
                        marginRight: '8px',
                        width: '35px'
                    }}
                >
                    {icons()[source]}
                </Avatar>
            </LightTooltip>
            <small
                data-testid="aliasesObjectText"
                style={{
                    fontSize: FontSizes[0],
                    overflow: 'hidden',
                    paddingRight: '8px',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}
            >
                {text}
            </small>
        </Box>
    );
};

export default Alias;
